import { keyframes } from 'styled-components';

export const mobileShowPopupAnimation = keyframes`
  0% {
    bottom: -100%;
  }
  100% {
    bottom: 0px;
  }
`;

export const mobileClosePopupAnimation = (currentBlockPos) => keyframes`
  0% {
    bottom: calc(0px - ${currentBlockPos}px);
  }
  100% {
    bottom: -100%;
  }
`;

export const desktopShowPopupAnimation = keyframes`
  0% {
    bottom: -208px;
  }
  100% {
    bottom: 30px;
  }
`;

export const desktopClosePopupAnimation = keyframes`
  0% {
    bottom: 30px;
  }
  100% {
    bottom: -208px;
  }
`;
